module.exports = __webpack_public_path__ + "img/overwhelming firepower.24597ab9.png";